import { createSlice } from "@reduxjs/toolkit";
import { SAMPLE_DOWNLOAD_MEMBER } from "../../../state";

const downloadMemberSampleSlice = createSlice({
  name: "DOWNLOAD_MEMBER_SAMPLE_SLICE",
  initialState: SAMPLE_DOWNLOAD_MEMBER,
  reducers: {
    startMemberSampleDownload: (state) => {
      state.memeberSampleLoading = true;
      state.memberSampleError = null;
    },
    successMemberSampleDownload: (state, action) => {
      state.memeberSampleLoading = false;
      state.memberFile = action.payload;
    },
    errorMemberSampleDownload: (state, action) => {
      state.memeberSampleLoading = false;
      state.memberSampleError = action.payload;
    },
  },
});

export const {
  startMemberSampleDownload,
  successMemberSampleDownload,
  errorMemberSampleDownload,
} = downloadMemberSampleSlice.actions;

export const downloadMemberSampleReducer = downloadMemberSampleSlice.reducer;
